import { HomeOutlined, MailOutlined, UserOutlined } from "@ant-design/icons";

export const USER_TYPE = [
  {
    label: "Caddy",
    value: 0,
  },
  {
    label: "Golfer",
    value: 1,
  },
];

export const GENDER = [
  {
    label: "ชาย",
    value: 1,
  },
  {
    label: "หญิง",
    value: 2,
  },
  {
    label: "ไม่ระบุ",
    value: 0,
  },
];

export const MODE_PREFERENCE = [
  {
    label: "เดิน (Walking)",
    value: "walking",
  },
  {
    label: "รถกอล์ฟ (Carting)",
    value: "carting",
  },
  {
    label: "ทั้งสอง (Carting or Walking)",
    value: "both",
  },
];

export const BOOKING_MODE_OPTIONS = [
  {
    label: "รถกอล์ฟ (Cart)",
    value: "carting",
  },
  {
    label: "เดิน (Walking)",
    value: "walking",
  },
];

// Tee-off transport for the "Book me a caddie" (tip-offer) create form.
// NOTE: values must match the backend tip_offers.play_mode contract exactly
// ('cart' | 'walking') — this is NOT the booking "carting" vocabulary.
export const TIP_OFFER_PLAY_MODE_OPTIONS = [
  {
    label: "รถกอล์ฟ (Cart)",
    value: "cart",
  },
  {
    label: "เดิน (Walking)",
    value: "walking",
  },
];

// Tee-off transport stored on a booking (jobs.play_mode), keyed on the backend
// values 'cart' | 'walking'. Mirrors the "Book me a caddie" LINE message labels
// and TIP_OFFER_PLAY_MODE_OPTIONS above (value -> display label for read views).
export const PLAY_MODE_LABELS = {
  cart: "รถกอล์ฟ (Cart)",
  walking: "เดิน (Walking)",
};

export const JOB_TYPE = [
  ["", "รอยืนยัน"],
  ["งานของฉัน", "การจองของฉัน"],
  ["ประวัติงาน", "ประวัติการจอง"],
];
export const JOB_MENUS = [
  {
    label: ["", "รอยืนยัน"],
    icon: <MailOutlined style={{ fontSize: 15 }} />,
    route: 0,
    key: "pending",
  },
  {
    label: ["งานของฉัน", "การจองของฉัน"],
    icon: <HomeOutlined style={{ fontSize: 15 }} />,
    route: 1,
    key: "upcomming",
  },
  {
    label: ["ประวัติงาน", "ประวัติการจอง"],
    icon: <UserOutlined style={{ fontSize: 15 }} />,
    route: 2,
    key: "history",
  },
];

export const phoneNumberPattern = /^(0[0-9]{9})$/;

export const formatPhoneNumber = (value) => {
  // Automatically format to 3-3-4 format (081-234-5678)
  if (!value) return value;
  return value
    .replace(/\D/g, "") // Remove non-numeric characters
    .replace(/(\d{3})(\d{3})(\d{4})/, "$1$2$3")
    .substring(0, 10); // Limit to 12 characters including dashes
};

export const PROFILE_MENUS = [
  [
    {
      label: (
        <div style={{ padding: 5 }}>
          <div>โปรไฟล์</div>
        </div>
      ),
      value: 0,
      validate_value: ["profile_picture_url", "display_name", "price"],
    },
    {
      label: (
        <div style={{ padding: 5 }}>
          <div>สนาม</div>
        </div>
      ),
      value: 1,
      validate_value: ["golf_course_id", "caddy_number"],
      // validate_value: ["golf_course_id", "caddy_number", "caddy_identity_image_url"],
    },
    {
      label: (
        <div style={{ padding: 5 }}>
          <div>การรับเงิน</div>
        </div>
      ),
      value: 2,
      validate_value: [
        "identity_number",
        "bank_id",
        "bank_user_name",
        "bank_number",
      ],
    },
    {
      label: (
        <div style={{ padding: 5 }}>
          <div>ส่วนตัว</div>
        </div>
      ),
      value: 3,
      validate_value: ["first_name", "last_name", "phone_number"],
    },
  ],
  [
    {
      label: (
        <div style={{ padding: 5 }}>
          <div>โปรไฟล์</div>
        </div>
      ),
      value: 0,
      validate_value: ["display_name"],
    },
    {
      label: (
        <div style={{ padding: 5 }}>
          <div>ส่วนตัว</div>
        </div>
      ),
      value: 3,
      validate_value: ["phone_number"],
    },
  ],
];

export const THAI_MONTHS = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];
export const THAI_DAY = [
  {
    full_day_name: "อาทิตย์",
    prefix_day_name: "อา.",
    prefix_day_name_en: "SUN",
    value: 0,
  },
  {
    full_day_name: "จันทร์",
    prefix_day_name: "จ.",
    prefix_day_name_en: "MON",
    value: 1,
  },
  {
    full_day_name: "อังคาร",
    prefix_day_name: "อ.",
    prefix_day_name_en: "TUE",
    value: 2,
  },
  {
    full_day_name: "พุธ",
    prefix_day_name: "พ.",
    prefix_day_name_en: "WED",
    value: 3,
  },
  {
    full_day_name: "พฤหัสบดี",
    prefix_day_name: "พฤ.",
    prefix_day_name_en: "THU",
    value: 4,
  },
  {
    full_day_name: "ศุกร์",
    prefix_day_name: "ศ.",
    prefix_day_name_en: "FRI",
    value: 5,
  },
  {
    full_day_name: "เสาร์",
    prefix_day_name: "ส.",
    prefix_day_name_en: "SAT",
    value: 6,
  },
];

export const TIPS_PERCEN = [
  { name: "10%", value: 10 },
  { name: "20%", value: 20 },
  { name: "50%", value: 50 },
];

export const DAYS_ENG_TO_THAI = {
  SUN: "อาทิตย์",
  MON: "จันทร์",
  TUE: "อังคาร",
  WED: "พุธ",
  THU: "พฤหัสบดี",
  FRI: "ศุกร์",
  SAT: "เสาร์",
};
